// extracted by mini-css-extract-plugin
export default {"INITIAL":"Chips_INITIAL__oJTBe","DELETABLE":"Chips_DELETABLE__PVrmH"};